import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import DataTableReact from '../../components/common/datatable/DataTableReact';
import { Dots, RightArrow, Block } from '../../assets/svg.js';
import NewRequest from '../../components/common/newRequest/NewRequest.jsx';
import RequestDetail from '../../components/common/requestDetail/RequestDetail.jsx';
import apiService from '../../services/apiService.js';
import Announcement from '../../components/common/announcementModal/Announcement.jsx';
import debounce from 'lodash.debounce';
import CustomDropDown from '../../components/common/dropdown/Dropdown.jsx';
import Rejected from '../../assets/icons/close-circle-fill.svg';
import Approved from '../../assets/icons/megaphone.svg';
import time from '../../assets/icons/time-fill.svg';
import circle from '../../assets/images/indeterminate-circle-fill.svg';

import ContractTermination from 'components/common/contractTermination/ContractTermination';
import ReasonOfTermination from 'components/common/reasonOfTermination/ReasonOfTermination';
import { toast } from 'react-toastify';
import useMedicalSpecialties from 'components/common/medSpecialty/MedicalSpecialty.jsx';

const medicalSpecialties = [
  { value: 'Cardiology', label: 'Cardiology' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'Neurology', label: 'Neurology' },
  { value: 'Pediatrics', label: 'Pediatrics' },
  { value: 'Psychiatry', label: 'Psychiatry' },
  { value: 'Obstetrics-and-gynecology', label: 'Obstetrics and Gynecology' },
  { value: 'Orthopedics', label: 'Orthopedics' },
  { value: 'Radiology', label: 'Radiology' },
  { value: 'Gastroenterology', label: 'Gastroenterology' },
  { value: 'Pulmonology', label: 'Pulmonology' },
  { value: 'Hematology', label: 'Hematology' },
  { value: 'Urology', label: 'Urology' },
  { value: 'Ophthalmology', label: 'Ophthalmology' },
  { value: 'Nephrology', label: 'Nephrology' },
  { value: 'Rheumatology', label: 'Rheumatology' },
];
const actionStatuses = [
  { value: 'Terminated', label: 'Terminated' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Expired', label: 'Expired' },
  { value: 'Approved', label: 'Approved' },
];

const ContractListing = () => {
  const [detailID, setDetailID] = useState(null);
  const [requestList, setRequestList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalStepper, setIsModalStepper] = useState(false);
  const [isAnnounce, setIsAnnounce] = useState(false);
  const [detailData, setDetailData] = useState();
  const [rowData, setRowData] = useState(null);
  const [id, setId] = useState(null);
  const [loading, setloading] = useState(false);
  const [page, setPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [contractDetail, setContractDetail] = useState(null);
  const [terminationConfirmationModal, setTerminationConfirmationModal] =
    useState(false);
  const [terminationReasonModal, setTerminationReasonModal] = useState(false);
  const [isTerminationLoading, setIsTerminationLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [filters, setFilters] = React.useState({
    contract_number: '',
    title: '',
    status: '',
    medicalSpecialties: [],
  });

  const medSp = useMedicalSpecialties();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const handleClick = () => {
    setIsModalOpen(true);
  };

  function getDuration(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Ensure the start date is earlier than the end date
    if (start > end) {
      return 'Start date cannot be later than end date';
    }

    // Calculate the difference in time
    const diffInMilliseconds = end - start;

    // Calculate years, months, and days
    const diffInYears = end.getFullYear() - start.getFullYear();
    const diffInMonths = end.getMonth() - start.getMonth() + diffInYears * 12;
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    // Return the appropriate duration based on the difference
    if (diffInMonths < 12) {
      if (diffInDays < 30) {
        return `${diffInDays} days`;
      } else {
        return `${Math.floor(diffInMonths)} months`;
      }
    } else {
      return `${Math.floor(diffInYears)} years`;
    }
  }

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const detailForm = async (data) => {
    setDetailID(data?._id);
    try {
      const response = await apiService.get(`contracts/${data?._id}`);
      setDetailID(null);
      if (response?.data) {
        localStorage.setItem('rowOriginalData', JSON.stringify(response?.data));
        localStorage.setItem('title', JSON.stringify(response?.data.title));
        if (user?.role === 'physician_management') {
          navigate(`/ContractDetail`);
        } else {
          navigate(`/HospitalContractDetail`);
        }
      }
    } catch (e) {
      setDetailID(null);
      console.log('Error fetching users:', e);
    }
  };

  const RenderLoader = () => {
    return (
      <div className="flex">
        <div className="w-4 h-4 border-2 border-gray-300 border-t-[#2D9F75] rounded-full animate-spin"></div>
      </div>
    );
  };

  const toggleDropdown = (idx) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  const toggleDropdown2 = (index) => {
    setTimeout(() => {
      setDropdownOpen(false);
    }, 2);
  };

  const terminateContract = async (terminationReason) => {
    setIsTerminationLoading(true);
    try {
      let payload = {
        termination_reason: terminationReason,
      };
      const response = await apiService.put(
        `contracts/${contractDetail?.original?._id}/terminate`,
        payload
      );
      if (response?.data) {
        let list = requestList;
        list[contractDetail?.index].status = 'terminated';
        setRequestList([...list]);
        setTerminationReasonModal(false);
        toast.info('Contract has been terminated.');
      }
      setIsTerminationLoading(false);
    } catch (e) {
      setIsTerminationLoading(false);
      console.log('Error fetching users:', e);
    }
  };

  const renderRowActions = ({ row, table }) => {
    const { index, original } = row;
    return (
      <div class="flex items-center justify-center gap-2 relative">
        {(user?.role === 'physician_management' ||
          user?.role === 'hospital_manager') && (
          <Dropdown
            isOpen={dropdownOpen[index] || false}
            toggle={() => toggleDropdown(index)}
            direction="down"
            className="relative"
          >
            <DropdownToggle
              style={{ backgroundColor: 'transparent', border: 0 }}
            >
              <Dots className="action-icon" />
            </DropdownToggle>
            <DropdownMenu
              container="body" // Ensures the dropdown is rendered in the body
              className="absolute z-50"
              style={{ transform: 'translateY(10px)' }} // Adjust dropdown position
            >
              <DropdownItem
                disabled={original.status !== 'approved'}
                onClick={() => {
                  setContractDetail(row);
                  setTerminationConfirmationModal(true);
                }}
              >
                <Block width="25px" height="25px" className="mr-2" />
                Terminate
              </DropdownItem>
              {/* Add more dropdown items here */}
            </DropdownMenu>
          </Dropdown>
        )}

        {row?.original?._id === detailID ? (
          <RenderLoader />
        ) : (
          <RightArrow
            className="action-icon"
            onClick={() => detailForm(original)}
          />
        )}
      </div>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const columns = [
    {
      id: 'Contract #',
      header: 'Contract #',
      accessorKey: 'reqNumber', // Accessing 'reqNumber' field in the data
      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.original?.contractNumber || '-'}
          </span>
        );
      },
    },
    {
      id: 'Name',
      header: 'Name',
      accessorKey: 'reqNumber', // Accessing 'reqNumber' field in the data
      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden  text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.original?.title || '-'}
          </span>
        );
      },
    },
    {
      id: 'Practitioners Specialty',
      header: 'Practitioners Specialty',
      accessorKey: 'specialties', // Accessing 'specialties' field in the data
      Cell: ({ row }) => {
        // const specialties = row?.original?.job_positions || [];
        // const maxVisible = 2; // Number of specialties to display initially

        // function getColorClass(index) {
        //   switch (index) {
        //     case 0:
        //       return "bg-[#EEEBFF] text-[#2B1664]"; // First item's color
        //     case 1:
        //       return "bg-[#FFF3E8] text-[#8D4D00]"; // Second item's color
        //     default:
        //       return "bg-[#F0F0F0] text-[#333333]"; // Default color for the rest
        //   }
        // }

        return (
          <div className="flex items-center justify-center px-2 py-0.5 rounded-full bg-[#EEEBFF] text-[#2B1664] text-center font-inter text-xs font-medium leading-[16px]">
            {row?.original?.announced_job?.medical_speciality?.name}
          </div>
        );
      },
    },
    {
      id: 'Level',
      header: 'Level',
      accessorKey: 'specialties', // Accessing 'specialties' field in the data
      muiTableHeadCellProps: {
        sx: (theme) => {
          return {
            display: 'flex',
            width: '128px',
            padding: '8px 12px 8px 42px',
            'align-items': 'center',
            gap: '10px',
            color: '#525866',
            'font-feature-settings':
              "'ss11' on, 'cv09' on, 'liga' off, 'calt' off",
            'font-family': 'Inter',
            'font-size': '14px',
            'font-style': 'normal',
            'font-weight': '400',
            'line-height': '20px' /* 142.857% */,
            'letter-spacing': '-0.084px',
            'background-color': '#F6F8FA !important',
            border: 'none',
          };
        },
      },
      accessorFn: ({ row }) => {
        const specialties = row?.original?.job_positions || [];
        const maxVisible = 2; // Number of specialties to display initially

        function getColorClass(index) {
          switch (index) {
            case 0:
              return 'bg-[#EEEBFF] text-[#2B1664]'; // First item's color
            case 1:
              return 'bg-[#FFF3E8] text-[#8D4D00]'; // Second item's color
            default:
              return 'bg-[#F0F0F0] text-[#333333]'; // Default color for the rest
          }
        }

        return (
          <div className="flex items-center justify-center px-2 py-0.5 rounded-full bg-[#FDEBFF] text-[#2B1664] text-center font-inter text-xs font-medium leading-[16px]">
            {row?.original?.announced_job?.speciality?.name}
          </div>
        );
      },
    },
    {
      id: 'contract_start_date',
      header: 'Contract Start Date',
      //   accessorKey: "totalNo", // Accessing 'totalNo' field in the data
      Cell: ({ row }) => {
        const givenDate = new Date(row?.original?.start_date);

        // Format the date
        const day = givenDate.getDate();
        const month = givenDate.toLocaleString('en-US', { month: 'short' });
        const year = givenDate.getFullYear() - 1;

        const formattedDate = `${day} ${month.toLowerCase()} ${year}`;
        return (
          <span className="font-sans font-[400] text-[12px] text-[#0A0D14]">
            {formattedDate}
          </span>
        );
      },
    },
    {
      id: 'Contract_end_date',
      header: 'Contract End Date',
      //   accessorKey: "dateOfRequest", // Accessing 'dateOfRequest' field in the data
      Cell: ({ row }) => {
        const givenDate = new Date(row?.original?.end_date);

        // Format the date
        const day = givenDate.getDate();
        const month = givenDate.toLocaleString('en-US', { month: 'short' });
        const year = givenDate.getFullYear() - 1;

        const formattedDate = `${day} ${month.toLowerCase()} ${year}`;
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#DF1C41] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {formattedDate || '-'}
          </span>
        );
      },
    },
    {
      id: 'duration',
      header: 'Duration',
      accessorKey: 'dateOfRequest', // Accessing 'dateOfRequest' field in the data
      Cell: ({ row }) => {
        return (
          <span className="font-sans font-[400] text-[12px] text-[#0A0D14]">
            {getDuration(row?.original?.start_date, row?.original?.end_date) ||
              '-'}
          </span>
        );
      },
    },
    {
      id: 'Status',
      header: 'Status',
      accessorKey: 'status', // Accessing 'status' field in the data
      Cell: ({ row }) => {
        let statusToReturn = {
          terminated: {
            icon: Rejected,
            text: 'Terminated',
          },
          pending: {
            icon: time,
            text: 'Pending',
          },
          expired: {
            icon: Rejected,
            text: 'Expired',
          },
          approved: {
            icon: Approved,
            text: 'Approved',
          },
          closed: {
            icon: null,
            text: 'Closed',
          },
          rejected: {
            icon: null,
            text: 'Rejected',
          },
        };
        return (
          <span className="flex justify-center px-[10px] py-[6px] items-center gap-[4px] rounded-md border border-[#E2E4E9] bg-white text-[#525866] font-inter text-xs font-medium leading-4 tracking-[0.02em]">
            {statusToReturn[row?.original?.status]?.icon && (
              <img
                src={statusToReturn[row?.original?.status]?.icon}
                alt="status"
                className="w-[16px] h-[16px]"
              />
            )}{' '}
            <p className="m-0 self-center">
              {statusToReturn[row?.original?.status]?.text}
            </p>
          </span>
        );
      },
    },
  ];

  const handleAnnounceClick = (row, id) => {
    setIsModalStepper(false);
    setRowData(
      row?.job_positions && row.job_positions !== '' ? row.job_positions : row
    );
    setId(id);
    setIsAnnounce(true);
  };

  const fetchRequests = async (updatedFilters, page, rowsPerPage) => {
    try {
      setloading(true);

      const payload = {
        contract_number: String(
          updatedFilters.contract_number || ''
        ).toLowerCase(),
        medicalSpecialties: String(
          updatedFilters.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        title: String(updatedFilters.title || '').toLowerCase(),
        status: String(updatedFilters.status || '').toLowerCase(),
      };
      const response = await apiService.get(
        `contracts?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );

      if (response?.code === 200) {
        setRequestList(response?.data?.data);
        setTotalRows(response?.data?.total);

        setloading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDebouncedChange = debounce(
    (updatedFilters, page, rowsPerPage) => {
      setloading(true);
      const payload = {
        contract_number: String(
          updatedFilters.contract_number || ''
        ).toLowerCase(),
        medicalSpecialties: String(
          updatedFilters.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        title: String(updatedFilters.title || '').toLowerCase(),
        status: String(updatedFilters.status || '').toLowerCase(),
      };
      apiService
        .get(`contracts?is_pagination=true&per_page=${rowsPerPage}`, payload)
        .then((response) => {
          setRequestList(response?.data?.data || []);
          setTotalRows(response?.data?.total);
          setloading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    500
  );

  const handleInputChange = (e) => {
    let value;
    let name;

    if (e !== null && e.target) {
      // Standard input or select element
      const { name: inputName, value: inputValue } = e.target;
      name = inputName;
      value = inputValue;
    } else {
      // Custom component like react-select
      name = 'actionStatus'; // Assuming custom component passes 'name'
      value = e; // Assuming value is passed in a custom event object
      if (Array.isArray(value)) {
        name = 'medicalSpecialties'; // Assign to medicalSpecialties
        value = value.map((item) => item);
      } else {
        console.log("It's not an array.", value);
      }
    }

    // Handle special case for 'medicalSpecialties' (if it's a comma-separated list)
    const updatedFilters = {
      ...filters,
      [name]:
        name === 'medicalSpecialties'
          ? value?.map(({ label, value }) => ({ label, value })) || []
          : value,
    };
    setFilters(updatedFilters);
    // Trigger the debounced API call
    handleDebouncedChange(updatedFilters, page, rowsPerPage);
  };

  const init = () => {
    fetchRequests(filters, page, rowsPerPage);
  };

  useEffect(() => {
    init();
  }, [page, rowsPerPage]);

  return (
    <div>
      {isAnnounce && (
        <Announcement
          rowData={rowData}
          requestDetails={detailData}
          setIsAnnounce={setIsAnnounce}
          id={id}
        />
      )}
      {isModalOpen && (
        <NewRequest onClose={handleClose} fetchRequests={fetchRequests} />
      )}

      {isModalStepper && (
        <RequestDetail
          requestDetails={detailData}
          handleAnnounceClick={handleAnnounceClick}
          onClose={setIsModalStepper}
        />
      )}

      <div className="flex justify-content-between items-center p-4 bg-gray-100 h-[60px]">
        <div className="grid grid-cols-4 gap-3">
          {/* English Name */}
          <input
            type="text"
            name="contract_number"
            placeholder="Enter Contract Number"
            value={filters.contract_number}
            onChange={(e) => {
              handleInputChange(e, page, rowsPerPage); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />

          <input
            type="text"
            name="title"
            placeholder="Enter Name"
            value={filters.title}
            onChange={(e) => {
              handleInputChange(e); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />

          {/* Action Status */}

          <CustomDropDown
            name="medicalSpecialties"
            value={
              filters.medicalSpecialties?.map((site) => ({
                label: site?.label,
                value: site?.value,
              })) || []
            }
            onFieldSelect={(e) => {
              handleInputChange(e, page, rowsPerPage);
            }}
            options={medSp?.map(({ name, _id, ...rest }) => ({
              label: name,
              value: _id,
              ...rest,
            }))}
            zIndex={'99999'}
            isMulti={true}
          />
        </div>
        <div className="flex justify-center items-center gap-2">
          <div className="mt-2 pl-2">Total Count:{requestList.length}</div>
        </div>
      </div>

      <DataTableReact
        data={requestList}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        loading={loading}
        totalRows={totalRows}
        setPage={setPage}
        shouldShowActions={true}
      />

      {terminationConfirmationModal && (
        <ContractTermination
          onConfirm={() => {
            setTerminationConfirmationModal(false);
            setTimeout(() => {
              setTerminationReasonModal(true);
            }, 200);
          }}
          onDismiss={() => setTerminationConfirmationModal(false)}
        />
      )}
      {terminationReasonModal && (
        <ReasonOfTermination
          isLoading={isTerminationLoading}
          setRejection={setTerminationReasonModal}
          rejectionReason={terminateContract}
        />
      )}
    </div>
  );
};

export default ContractListing;
